import Immutable from 'seamless-immutable';
import _ from 'lodash';

export function filter(predicate, items) {
  return items.filter(predicate);
}

export function find(predicate, items) {
  return items.find(predicate) || Immutable({});
}

export function findById(id, items) {
  return find(item => item.id === id, items);
}

export function map(fn, items) {
  return items.map(fn);
}

const memoizedSortBy = () => {
  const _cache = {};
  let _items, _immutableItems, _key;

  return (iteratee, items) => {
    _key = JSON.stringify(items);
    if (_cache[_key]) return _cache[_key];
    else {
      // because sort mutates, we have to break out items into a new object, deeply copying everything. This is equivalent to clone...I guess
      _items = Immutable.asMutable(items, { deep: true });
      // sort and repackage into a new Immutable structure
      _immutableItems = Immutable(_.sortBy(_items, iteratee));
      _cache[JSON.stringify(_immutableItems)] = _immutableItems;
      return _immutableItems;
    }
  };
};

export const sortBy = memoizedSortBy();

/**
 * mapTo - morph a set of items having given attributes onto other attibutes. handy when you have a single select and your items have id and name but the
 * combo box requires text and value
 * @param {array} items list of items to map through
 * @param {object} fields object representing fields to map to. key is the original field name, value is the field to map to
 *
 */
const mapTo = (
  items,
  fields = {
    name: 'text',
    id: 'value',
  }
) => {
  return _.reduce(
    items,
    (acc, item) => {
      const _out = {};
      _.forIn(fields, (value, key) => {
        _out[value] = _.get(item, key, '');
      });

      acc.push(_out);
      return acc;
    },
    []
  );
};

export const baseCollection = {
  filter,
  find,
  findById,
  map,
  sortBy,
  mapTo,
};
